exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "@-webkit-keyframes _3EST6oCtVB2xq2M0jsVEuK {\n  to { -webkit-transform: rotate(1turn); transform: rotate(1turn); }\n}\n\n@keyframes _3EST6oCtVB2xq2M0jsVEuK {\n  to { -webkit-transform: rotate(1turn); transform: rotate(1turn); }\n}\n\n._3ACDWkx0G0THCNHDhybqcG {\n  position: relative;\n  display: inline-block;\n\n  -webkit-animation: _3EST6oCtVB2xq2M0jsVEuK 850ms infinite;\n\n          animation: _3EST6oCtVB2xq2M0jsVEuK 850ms infinite;\n  -webkit-animation-timing-function: linear;\n          animation-timing-function: linear;\n}\n._16tsIBn0G9zOWXPKJK8eMO {\n  width: 20px;\n  height: 20px;\n}\n._1KynmXTLeIUKXuXhg_qJ8K {\n  width: 16px;\n  height: 16px;\n}\n.sQ4YUnZ4ivnCvsb5E2oqP {\n  width: 40px;\n  height: 40px;\n}\n.imb-hry0NhajmT-7gA3hG {\n  width: 60px;\n  height: 60px;\n}\n._23oV1s2-VX46EuYWK-jKNm {\n}\n.PBKdCzLvbf0_NBe5RoERO {\n}\n._1M_sVundbdl_rV8PDrpTLu {\n}\n._3Xrh43n0o7Ww1Aytv5rEbH {\n}\n", ""]);

// exports
exports.locals = {
	"progress": "_3ACDWkx0G0THCNHDhybqcG",
	"spin": "_3EST6oCtVB2xq2M0jsVEuK",
	"small": "_16tsIBn0G9zOWXPKJK8eMO",
	"xsmall": "_1KynmXTLeIUKXuXhg_qJ8K",
	"medium": "sQ4YUnZ4ivnCvsb5E2oqP",
	"large": "imb-hry0NhajmT-7gA3hG",
	"progress-small": "_23oV1s2-VX46EuYWK-jKNm _3ACDWkx0G0THCNHDhybqcG _16tsIBn0G9zOWXPKJK8eMO",
	"progress-xsmall": "PBKdCzLvbf0_NBe5RoERO _3ACDWkx0G0THCNHDhybqcG _1KynmXTLeIUKXuXhg_qJ8K",
	"progress-medium": "_1M_sVundbdl_rV8PDrpTLu _3ACDWkx0G0THCNHDhybqcG sQ4YUnZ4ivnCvsb5E2oqP",
	"progress-large": "_3Xrh43n0o7Ww1Aytv5rEbH _3ACDWkx0G0THCNHDhybqcG imb-hry0NhajmT-7gA3hG"
};


//////////////////
// WEBPACK FOOTER
// /builds/alivecorbackend/kardia-pro/node_modules/css-loader?{"importLoaders":1,"modules":{"localIdentName":"[name]__[local]___[hash:base64:5]"}}!/builds/alivecorbackend/kardia-pro/node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null,null]}!./src/views/components/Loading/Loading.css
// module id = 3752
// module chunks = 25